import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <BookOpen size={28} />
              <span>StudioInsieme</span>
            </Link>
            <p className="footer-description">
              Doposcuola, supporto compiti e metodo di studio per studenti di elementari e medie, online e in presenza.
            </p>
          </div>

          <div className="footer-section">
            <h3>Servizi</h3>
            <ul className="footer-links">
              <li>Supporto compiti</li>
              <li>Metodo di studio</li>
              <li>Recupero scolastico</li>
              <li>Percorsi per DSA/BES</li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contatti</h3>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <span>info@studioinsieme.it</span>
              </li>
              <li>
                <Phone size={18} />
                <span>+39 333 123 4567</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>Online e in presenza</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Informazioni</h3>
            <ul className="footer-links">
              <li><Link to="/contatti">Contatti</Link></li>
              <li><Link to="/iscrizione">Iscrizione</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/termini">Termini e condizioni</Link></li>
              <li><Link to="/rimborsi">Rimborsi e cancellazioni</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} StudioInsieme. Tutti i diritti riservati.</p>
          <div className="footer-legal">
            <Link to="/privacy" className="footer-link-small">Privacy Policy</Link>
            <Link to="/termini" className="footer-link-small">Termini e condizioni</Link>
            <Link to="/rimborsi" className="footer-link-small">Rimborsi</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
